var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "Requirements",
      on: {
        click: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "container",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("ul", [
            _c("li", [_vm._v(_vm._s(_vm.$t("REQUIREMENTS.TITLE")))]),
            _c("br"),
            _c("li", [_vm._v(_vm._s(_vm.$t("REQUIREMENTS.TEXTA")))]),
            _c("li", [_vm._v(_vm._s(_vm.$t("REQUIREMENTS.TEXTB")))]),
            _c("li", [_vm._v(_vm._s(_vm.$t("REQUIREMENTS.TEXTC")))]),
            _c("li", [_vm._v(_vm._s(_vm.$t("REQUIREMENTS.TEXTD")))]),
            _c("li", [
              _vm._v(" " + _vm._s(_vm.$t("REQUIREMENTS.TEXTE")) + " ")
            ]),
            _c("li", [_vm._v(" " + _vm._s(_vm.$t("REQUIREMENTS.TEXTE")) + " ")])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }